export default { version: '7.0.0' }
